var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputComma",staticClass:"input01",attrs:{"type":"text","placeholder":_vm.placeholder,"disabled":_vm.disabled,"inputmode":"numeric"},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"blur":_vm.handleBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }